<script>
	import { Button } from '$lib/components/ui/button';
	import { ArrowRight } from 'lucide-svelte';
	import backgroundImage from '$lib/assets/golf/links-dunes-sunset.jpg?enhanced';

	// Everything named here is already offered on /tasmanian-golf-experiences.
	const options = [
		'Private golf escapes',
		'Corporate golf',
		'Golf club tours',
		'King Island + Tasmania',
		'Golf + partner experiences'
	];
</script>

<section class="bg-white pb-16 lg:pb-24">
	<div class="mx-auto max-w-7xl px-4">
		<div class="relative overflow-hidden rounded-3xl">
			<enhanced:img
				src={backgroundImage}
				alt="Golfers teeing off on a coastal links course in Tasmania at sunset"
				class="absolute inset-0 h-full w-full object-cover"
				sizes="(min-width: 1280px) 1280px, 100vw"
				loading="lazy"
			/>
			<div class="absolute inset-0 bg-[#0d211d]/75"></div>

			<div
				class="relative grid grid-cols-1 gap-10 p-8 sm:p-12 lg:grid-cols-12 lg:items-center lg:p-16"
			>
				<div class="lg:col-span-7">
					<p class="text-sm font-semibold uppercase tracking-widest text-[#ffd451]">
						Prefer it built around your group?
					</p>
					<h2
						class="mt-3 font-heading text-3xl font-semibold tracking-tight text-white sm:text-4xl"
					>
						Private Tasmanian golf experiences
					</h2>
					<p class="mt-6 leading-7 text-white/85">
						Legends of Tasmania is our set-departure journey. If you'd rather choose your own
						courses, dates and pace, we also create private, bespoke golf experiences across
						Tasmania and King Island — with premium accommodation, private transfers, charter
						flights and experiences for the non-golfers in your group.
					</p>
					<ul class="mt-6 flex flex-wrap gap-2">
						{#each options as option}
							<li
								class="rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-white"
							>
								{option}
							</li>
						{/each}
					</ul>
				</div>

				<div class="lg:col-span-5 lg:justify-self-end">
					<Button
						href="/tasmanian-golf-experiences"
						data-sveltekit-prefetch
						class="w-full rounded-full bg-tt-red px-8 font-semibold hover:bg-tt-red/90 sm:w-auto lg:text-lg"
					>
						Explore private golf experiences <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
					<p class="mt-4 text-sm leading-6 text-white/70 lg:text-right">
						Tell us what you want to play. We'll build the journey.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
